import { useDevLogger } from '../dev-logger/index.js'
import { NAME } from './consts.js'

export const logger = useDevLogger(NAME)
